export const initialValues = () => ({
  name: "",
  last_name: "",
  cpd: "",
  email: "",
  password: "",
  confirmPassword: "",
  phone: "",
  department: "",
  group: "",
  screens: [],
});
